(function($) {
	$('ul.brands-filter > li').on('click', function(e) {
		// Set the button as active
		$(this).addClass('active');
		$(this).siblings().removeClass('active');

		// Set the selected section as active
		const targetClass = $(e.target).data('target');

		// Find the number of active items
		const totalItems = $('.brands-section > .section-items > li').length;

		if ( targetClass === '*' ) {
			$('section.brands-section').addClass('active');
			$('.brands-count').text(`Visar alla ${totalItems} varumärken`);
		} else {
			$(`section.${targetClass}`).addClass('active').siblings().removeClass('active');
			const activeItems = $('.brands-section.active > .section-items > li').length;
			$('.brands-count').text(`Visar ${activeItems} av ${totalItems} varumärken`);
		}
	});
})(jQuery);